import { Route, Routes } from 'react-router-dom';
import React, { ReactElement } from 'react';
import { IPageBuilderConfig } from 'models/route';
import { PageComponentTypes } from 'constants/PageComponentTypes';
import { AuthPage } from 'pages/AuthPage';
import { useAuth } from 'models/authContext';

interface IPageBuilder {
  config: IPageBuilderConfig[];
}

const PageTemplate = ({ config }: IPageBuilder) => {
  const { isAuthenticated } = useAuth();

  const redirectRoute = (route: IPageBuilderConfig) => {
    const { isProtected, componentType } = route;
    const Component = PageComponentTypes[componentType];
    return isProtected && !isAuthenticated ? <AuthPage /> : <Component />;
  };

  const renderRoutes = () =>
    config.map(
      (route: IPageBuilderConfig): ReactElement => (
        <Route key={route.componentType} path={route.route} element={redirectRoute(route)}>
          {route.nestedRoutes?.map(
            (nestedRoute: IPageBuilderConfig): ReactElement => (
              <Route
                key={nestedRoute.componentType}
                path={nestedRoute.route}
                element={redirectRoute(route)}
              />
            ),
          )}
        </Route>
      ),
    );
  document.addEventListener(
    'itemInserted',
    () => {
      renderRoutes();
    },
    false,
  );

  return <Routes>{renderRoutes()}</Routes>;
};

export { PageTemplate };
